<template>
  <section id="hero">
    <!-- <v-img
      :src="require('@/assets/blackpurp.jpg')"
      :min-height="minHeight"
      gradient="to right, rgba(5, 11, 31, .65), rgba(5, 11, 31, .65)"
    > -->
    <!-- <v-col>
      <v-slide-x-reverse-transition appear>
        <v-row>
          <v-responsive height="50%" max-width="1500" width="100%">
            <base-body>
              <v-col>
                <v-row>
                  <p
                    color="rgb(34, 34, 34)"
                    :class="[
                      $vuetify.breakpoint.mdAndUp ? 'display-1' : 'headline',
                    ]"
                    class="pb-10 pl-16 mt-16 ml-16 font-weight-bold"
                  >
                    About Us
                  </p>
                  <v-spacer></v-spacer>
                  <img
                    alt="team illustration"
                    height="700"
                    :src="require('@/assets/team.png')"
                  />
                </v-row>
              </v-col>
            </base-body>
          </v-responsive>
        </v-row>
      </v-slide-x-reverse-transition>
    </v-col> -->

    <v-row style="margin: 16px !important;">
      <v-col class="text-center mb-12" id="Philosophy" cols="12" md="12">
        <base-section-heading
          color="primary--text secondary lighten-2"
          title="WHo are we?"
        />

        <p style=" line-height: 1.3rem !important;" class="subtitle-1">
          We are a tech startup that is passionate about helping community
          members safely connect and transact with each other.
        </p>
        <br />
        <p style=" line-height: 1.3rem !important;" class="subtitle-1">
          We are building safe, connected, transactional communities to make it
          easier and more sustainable to rent and borrow what you need from
          those around you.
        </p>
        <p style=" line-height: 1.3rem !important;" class="subtitle-1">
          <br />
          <strong
            >Empowering communities to become more connected through shared
            ownership.</strong
          >
        </p>
      </v-col>
    </v-row>

    <v-sheet class="mt-16 d-flex flex-column">
      <svg
        class="logos-bg"
        style="fill: #f2f5f8"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1442 163"
      >
        <path
          d="m-3.90909,6l48.30303,16c48.30303,16 144.90908,48 241.51514,48c96.60606,0 193.21211,-32 289.81817,-32c96.60606,0 193.21211,32 289.81817,53.3c96.60606,21.7 193.21211,31.7 289.81817,16c96.60606,-16.3 193.21211,-58.3 241.51514,-80l48.30303,-21.3l0,160l-48.30303,0c-48.30303,0 -144.90908,0 -241.51514,0c-96.60606,0 -193.21211,0 -289.81817,0c-96.60606,0 -193.21211,0 -289.81817,0c-96.60606,0 -193.21211,0 -289.81817,0c-96.60606,0 -193.21211,0 -241.51514,0l-48.30303,0l0,-160z"
        />
      </svg>
    </v-sheet>

    <v-sheet color="#F2F5F8">
      <base-section-heading
        color="primary--text secondary lighten-2"
        title="The Mission"
        class="mb-n3"
      />
      <v-container>
        <v-row>
          <v-col
            v-for="card in cards"
            :key="card.title"
            :class="$vuetify.breakpoint.smAndDown ? 'grid' : ''"
            cols="12"
            md="3"
          >
            <base-info-card v-bind="card" />
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>

    <v-sheet color="#F2F5F8">
      <div class="footer-bg"></div>
    </v-sheet>

    <v-sheet color="#F8B58E">
      <base-section-heading
        color="white--text secondary lighten-2"
        title="The Team"
      />

      <v-row class="justify-center">
        <v-col align="center" id="Philosophy" cols="12" md="4">
          <h2
            :class="[$vuetify.breakpoint.mdAndUp ? 'display-1' : 'headline']"
            class="mb-4 secondary--text"
          >
            Darren De Abreu
          </h2>
          <p class="caption">Co-Founder and Head of Growth</p>
          <p style="text-align: center;" class="subtitle-1 ml-8 mr-8 mb-8">
            “If you aren’t failing, you aren’t trying hard enough”
          </p>

          <v-img
            style="max-width: 60%;"
            alt="darren photo"
            :src="require('@/assets/daz.png')"
          />
        </v-col>

        <v-col align="center" cols="12" md="4">
          <h2
            :class="[$vuetify.breakpoint.mdAndUp ? 'display-1' : 'headline']"
            class="mb-4 secondary--text"
          >
            Jamie Seymour
          </h2>
          <p class="caption">Co-Founder and Head of Product Development</p>
          <p style="text-align: center;" class="subtitle-1 ml-8 mr-8 mb-8">“Great things never come from comfort zones”</p>

          <v-img
            class="ml-3"
            style="max-width: 60%;"
            alt="Jamie photo"
            :src="require('@/assets/jamie.png')"
          />
        </v-col>

        <v-col class="center" cols="12" md="4">
          <h2
            :class="[$vuetify.breakpoint.mdAndUp ? 'display-1' : 'headline']"
            class="mb-4 secondary--text"
          >
            Aidan Katzef
          </h2>
          <p class="caption">Head Developer</p>
          <p style="text-align: center;" class="subtitle-1 ml-8 mr-8 mb-8">“If opportunity doesn't knock, build a door”</p>

          <v-img
            class="ml-3"
            style="max-width: 60%;"
            alt="Jamie photo"
            :src="require('@/assets/aidan.png')"
          />
        </v-col>
      </v-row>
    </v-sheet>

    <v-sheet class="pb-n3" color="#F8B58E">
      <svg
        id="curveUpColor"
        class="mb-n2"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        width="100%"
        height="100"
        viewBox="0 0 100 100"
        preserveAspectRatio="none"
      >
        <path d="M0 100 C 20 0 50 0 100 100 Z" />
      </svg>
    </v-sheet>

    <v-sheet color="#F2F5F8">
      <base-section-heading
        class="text-h3"
        color="primary--text secondary lighten-2"
        title="The Goal"
      />

      <p class="text-body-1 text-center ml-9 mr-9 pb-10">
        <!-- We plan to become Africa's biggest P2P transactional e-Rental
        marketplace, assisting businesses to unlock incremental value, and
        enabling users to make money off their items, while affording access to
        people who need short term access to items.<br /> -->
        We want to redefine what it means to use and to own. Gone are the days
        of wasted purchases and scarcity. We should be able to leverage our
        communities so that scarcity is replaced with access.
      </p>

      <div class="grid">
        <img
          alt="globe illustration"
          :src="require('@/assets/svgs/earth-2.svg')"
        />
      </div>
    </v-sheet>
  </section>
</template>

<script>
export default {
  name: "SectionHero",

  metaInfo: {
    title: "About",
    titleTemplate: "Strapp - About us 🙋‍♂️",
    content:
      "An online rental marketplace where you can rent out your household items and equipment to others for short term periods.",
    htmlAttrs: { lang: "en" },
    meta: [
      { charset: "utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
    ],
  },

  data: () => ({
    // particleImage: require("@/assets/hero-bg-effect.png"),
    // screenshots: require("@/assets/app-screenshot-bg-effect.png"),
    // altText: "particle",
    // altText3: "bouncing",
    // Screenshots: "bouncing particle ui",
    cards: [
      {
        title: "To build transactional communities",
        subtitle: "Collaborative",
        text: "We believe humans were meant to share and collaborate, that’s why we are making it easier to connect with those around you.",
        callout: require("@/assets/fontawesome/users-duotone.svg"),
      },
      {
        title: "To Provide a safe and central platform",
        subtitle: "Safe and Central",
        text: "We are making it safer and easier than ever to transact with others in your community by connecting  you to your neighbours in one central place.",
        callout: require("@/assets/fontawesome/user-shield-duotone.svg"),
      },
      {
        title: "To decrease overproduction",
        subtitle: "Eco freindly",
        text: "Reduce the strain on the environment by decreasing the reliance on overproduced items and use what others already own.",
        callout: require("@/assets/fontawesome/leaf-heart-duotone.svg"),
      },
      {
        title: "Increase Access",
        subtitle: "Flexible",
        text: "The first safe peer-2-peer transactional marketplace in Africa.",
        callout: require("@/assets/fontawesome/handshake-duotone.svg"),
        //  callout: require("@/assets/svgs/mindmap-1.svg")
      },
    ],
  }),

  computed: {
    minHeight() {
      const height = this.$vuetify.breakpoint.mdAndUp ? "100vh" : "50vh";

      return `calc(${height} - ${this.$vuetify.application.top}px)`;
    },
  },
};
</script>

<style lang="scss">
$color1: #f8b58e;

.ss-style-halfcircle::before,
.ss-style-halfcircle::after {
  left: 50%;
  z-index: 10;
  width: 100px;
  height: 110px;
  border-radius: 50%;
  background: inherit;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}

.ss-style-halfcircle::before {
  top: -50px;
}

.ss-style-halfcircle::after {
  bottom: -50px;
}

#curveUpColor path,
#curveDownColor path {
  fill: #f2f5f8;
  stroke: #f2f5f8;
}

#bigHalfCircle path {
  fill: #f2f5f8;
  stroke: #f2f5f8;
}
</style>

<style>
.footer-bg {
  background-color: #f8b58e;

  position: relative;
  overflow: hidden;
  z-index: 1;

  height: 100px;
  clip-path: polygon(
    0% 65%,
    1% 64.95%,
    2% 64.8%,
    3% 64.6%,
    4% 64.3%,
    5% 63.9%,
    6% 63.45%,
    7% 62.9%,
    8% 62.25%,
    9% 61.55%,
    10% 60.8%,
    11% 59.95%,
    12% 59.05%,
    13% 58.1%,
    14% 57.1%,
    15% 56.05%,
    16% 55%,
    17% 53.9%,
    18% 52.8%,
    19% 51.65%,
    20% 50.5%,
    21% 49.35%,
    22% 48.2%,
    23% 47.05%,
    24% 45.9%,
    25% 44.8%,
    26% 43.75%,
    27% 42.75%,
    28% 41.75%,
    29% 40.8%,
    30% 39.9%,
    31% 39.1%,
    32% 38.35%,
    33% 37.65%,
    34% 37.05%,
    35% 36.5%,
    36% 36.05%,
    37% 35.65%,
    38% 35.35%,
    39% 35.15%,
    40% 35.05%,
    41% 35%,
    42% 35.05%,
    43% 35.2%,
    44% 35.45%,
    45% 35.75%,
    46% 36.15%,
    47% 36.65%,
    48% 37.2%,
    49% 37.85%,
    50% 38.55%,
    51% 39.35%,
    52% 40.2%,
    53% 41.1%,
    54% 42.05%,
    55% 43.05%,
    56% 44.1%,
    57% 45.15%,
    58% 46.3%,
    59% 47.4%,
    60% 48.55%,
    61% 49.7%,
    62% 50.85%,
    63% 52%,
    64% 53.15%,
    65% 54.25%,
    66% 55.35%,
    67% 56.4%,
    68% 57.45%,
    69% 58.4%,
    70% 59.35%,
    71% 60.2%,
    72% 61.05%,
    73% 61.8%,
    74% 62.45%,
    75% 63.05%,
    76% 63.6%,
    77% 64.05%,
    78% 64.4%,
    79% 64.7%,
    80% 64.85%,
    81% 65%,
    82% 65%,
    83% 64.9%,
    84% 64.75%,
    85% 64.5%,
    86% 64.2%,
    87% 63.75%,
    88% 63.25%,
    89% 62.7%,
    90% 62.05%,
    91% 61.3%,
    92% 60.5%,
    93% 59.65%,
    94% 58.75%,
    95% 57.8%,
    96% 56.8%,
    97% 55.75%,
    98% 54.65%,
    99% 53.55%,
    100% 52.4%,
    100% 100%,
    0% 100%
  );
}

.grid {
  display: grid;
  place-items: center;
}
.hero-button {
  color: transparent;
  transition: 0.5s;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease 0s;
}
.center {
  display: grid;
  place-items: center;
}

.hero-button:hover {
  box-shadow: 0px 15px 20px rgba(46, 229, 157, 0.4);
  transform: translateY(-7px);
}
.particle-bg {
  position: absolute;
  top: 2%;
  left: 80%;
  z-index: 2;
}
.particle-bg img {
  animation: spin 27s linear infinite;
}
@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}

.background-shape {
  position: absolute;
  animation-name: bobbingAnim;
  animation-duration: 2s;
  padding: 0 7px 7px;

  animation-iteration-count: infinite;
  animation-play-state: running;
}
@keyframes bobbingAnim {
  0% {
    transform: translate(0px, 0px);
    animation-timing-function: ease-in-out;
  }

  50% {
    transform: translate(0px, 14px);
    animation-timing-function: ease-in-out;
  }

  100% {
    transform: translate(0px, 0px);
    animation-timing-function: ease-in-out;
  }
}
.background-shape img {
  max-width: 90%;
}
</style>
